import * as swcHelpers from '@swc/helpers';
import { getGraphQLPaymentMethodName } from '../../StepPayment/utils/get-payment-method-name.js';

const getSelectedPaymentDetails = (paymentState)=>{
    const paymentInfo = paymentState === null || paymentState === void 0 ? void 0 : paymentState.payments[0].obj;
    if (!paymentInfo) {
        return undefined;
    }
    const paymentMethod = paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.paymentMethodInfo.method;
    return swcHelpers.objectSpread({}, {
        data: {},
        isValid: true
    }, {
        type: getGraphQLPaymentMethodName(paymentMethod),
        result: (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.custom.fields.paymentMethodDetails) ? JSON.parse(paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.custom.fields.paymentMethodDetails) : {}
    });
};

export { getSelectedPaymentDetails };
//# sourceMappingURL=getSelectedPaymentDetails.js.map
